import { Injectable } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Shipment } from './shipment.model';

@Injectable()
export abstract class DeleteTripPopup {
    abstract OpenDeleteTripConfirmation(shipment: Shipment, closePopupOnSuccess?: BsModalRef): void;
}
